export default {
  addToken(state, token) {
    state.token = token
  },

  updateAuth(state, res) {
    state.id = res.id
    state.name = res.name
    state.email = res.email
    state.is_mate = res.is_mate
    state.company = res.company
    state.avatarPath = res.avatar_path
    state.unread = res.unread
    state.notifications = res.notifications
    state.subscription = res.subscription
    state.contract_plan = res.contract_plan
    state.permission = res.permission
    state.enable_content_id = res.enable_content_id
    state.enable_copyright_operation = res.enable_copyright_operation
    state.invoice = res.invoice
    state.enable_link_map = res.enable_link_map
    state.enable_release_limit = res.enable_release_limit
    state.remaining_release_count = res.remaining_release_count
    state.has_exceeded_limit_release = res.has_exceeded_limit_release
  },

  removeToken(state) {
    state.token = ''
  },
}
